import { JSX } from 'react'

import { TransitionStep } from '../TransitionStep'
import { InitializeStepProps } from './types'
import { useInitializeStepState } from './useInitializeStepState'

export const InitializeStep = (initializeStepProps: InitializeStepProps): JSX.Element => {
  const { isLoading, hasError, exit } = useInitializeStepState(initializeStepProps)
  const { testId } = initializeStepProps
  return <TransitionStep isLoading={isLoading} isErrored={hasError} onAbort={exit} error={undefined} testId={testId} />
}
